import { BooleanInput, Edit, NumberInput, SelectInput, SimpleForm, TextInput, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { levelOptions, typeOptions } from './constants';
import HolidayTemplateDateInputs from './HolidayTemplateDateInputs';
import { transformHolidayTemplate, validateHolidayTemplate } from './holidayTemplateForm';

const HolidayTemplatesEdit = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Edit
      mutationMode="pessimistic"
      transform={transformHolidayTemplate}
      mutationOptions={{
        onSuccess: () => {
          notify('Saved');
          navigate(-1);
        }
      }}
    >
      <SimpleForm validate={validateHolidayTemplate}>
        <TextInput disabled source="id" label="UUID" />
        <TextInput source="country" label="Country (2-char ISO)" inputProps={{ maxLength: 2 }} isRequired />
        <TextInput source="name" label="Name" isRequired />
        <SelectInput source="type" label="Type" choices={typeOptions} isRequired />
        <SelectInput source="level" label="Level" choices={levelOptions} isRequired />
        {/* Drives whether Start/End collect a time of day. */}
        <BooleanInput source="allDay" label="All Day" helperText="On: a whole calendar day. Off: an event with a start and end time." />
        <HolidayTemplateDateInputs />
        <BooleanInput source="paid" label="Paid" />
        <BooleanInput source="repeatAnnually" label="Repeat Annually" />
        <NumberInput source="legacyId" label="Legacy ID" />
      </SimpleForm>
    </Edit>
  );
};

export default HolidayTemplatesEdit;
